import React, { useLayoutEffect, useState } from 'react';
import APIS from '../../api/api';
import View from '../../view/guideline/guideline';
import QaGroup from '../../model/guideline/qaData';
import GuidelineData from '../../model/guideline/guidelineData';

const Presenter: React.FC = () => {

    const [qaGroupInfo, SetQaGroup] = useState<QaGroup[]>([]);
    const [guidelineInfo, SetGuideline] = useState<GuidelineData>({revisionDate: "", text: "", simpleExplanation: ""});
    const [isError, SetIsError] = useState<boolean>(false);
    const [isSuccess, SetIsSuccess] = useState<boolean>(false);

    const guidelineQa = () => {
        APIS.guidelinePage({}).then((res =>{
            // console.log("API Success!!!!!!!!");

            // レスポンスセット
            SetQaGroup(res.qaGroupInfo);
            SetGuideline(res.guidelineInfo);
            SetIsSuccess(true);

        })).catch((err) => {
            // console.log("API Error : " + err);
            SetIsError(true);
        });
    }

    useLayoutEffect(() => {
        guidelineQa();
    }, []);

    return <View qaGroupInfo={qaGroupInfo} guidelineInfo={guidelineInfo} isError={isError} isSuccess={isSuccess}/>;
};

export default Presenter;